import {
  Select,
  InputLabel,
  ListItemIcon,
  Checkbox,
  Tooltip,
} from '@mui/material';

import {
  FilterFormControl,
  StyledMenuItem,
  FiltersGrid,
  FiltersGridContainer,
} from '../styles';
import { PaperWithSearch, currentFilterKeyRef, listboxRef } from './FilterDropdown';
import FilterSelectIcon from './FilterSelectIcon';

const MAX_OPTION_LENGTH = 30;

const truncateOption = (text) =>
  text.length > MAX_OPTION_LENGTH ? `${text.slice(0, MAX_OPTION_LENGTH)}...` : text;

const FiltersSection = ({
  filtersConfig,
  newFilters,
  filterSearchTerms,
  setFilterSearchTerms,
  openFilterKey,
  setOpenFilterKey,
  handleNewFilter,
}) => (
  <FiltersGridContainer container spacing={1.5} justifyContent="space-between">
    {filtersConfig.map((filter) => {
      const options = filter.options.filter((opt) => opt !== 'All');
      const searchTerm = (filterSearchTerms[filter.key] || '').toLowerCase();
      const filteredOptions = searchTerm
        ? options.filter((opt) => opt.toLowerCase().includes(searchTerm))
        : options;
      const selected = newFilters[filter.key] || [];

      return (
        <FiltersGrid item key={filter.key}>
          <FilterFormControl size="small" variant="outlined">
            <InputLabel id={`${filter.key}-label`} shrink={selected.length > 0}>
              {filter.label}
            </InputLabel>
            <Select
              labelId={`${filter.key}-label`}
              value={selected}
              open={openFilterKey === filter.key}
              onOpen={() => {
                currentFilterKeyRef.current = filter.key;
                setOpenFilterKey(filter.key);
              }}
              onClose={() => {
                setOpenFilterKey(null);
                setFilterSearchTerms((prev) => ({ ...prev, [filter.key]: '' }));
              }}
              onChange={handleNewFilter(filter.key)}
              IconComponent={(props) => (
                <FilterSelectIcon
                  {...props}
                  selected={selected}
                  filterKey={filter.key}
                  onClear={(key) => handleNewFilter(key)({ target: { value: [] } })}
                />
              )}
              multiple
              renderValue={(chosen) => {
                const text = chosen.length === 0 ? 'All' : chosen.join(', ');
                const display = truncateOption(text);
                if (text.length > MAX_OPTION_LENGTH) {
                  return (
                    <Tooltip title={text} placement="top" enterDelay={500}>
                      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{display}</span>
                    </Tooltip>
                  );
                }
                return display;
              }}
              MenuProps={{
                variant: 'menu',
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left',
                },
                transitionDuration: 0,
                transformOrigin: {
                  vertical: 'top',
                  horizontal: 'left',
                },
                PaperProps: {
                  component: PaperWithSearch,
                },
                slotProps: {
                  list: {
                    ref: (el) => {
                      listboxRef.current = el;
                    },
                  },
                },
                autoFocus: false,
              }}
            >
              {filteredOptions.map((opt) => (
                <StyledMenuItem key={opt} value={opt}>
                  <ListItemIcon>
                    <Checkbox
                      checked={selected.indexOf(opt) > -1}
                      disableRipple
                      size="small"
                    />
                  </ListItemIcon>
                  {opt.length > MAX_OPTION_LENGTH ? (
                    <Tooltip title={opt} placement="top" enterDelay={1000}>
                      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
                        {truncateOption(opt)}
                      </span>
                    </Tooltip>
                  ) : (
                    opt
                  )}
                </StyledMenuItem>
              ))}
            </Select>
          </FilterFormControl>
        </FiltersGrid>
      );
    })}
  </FiltersGridContainer>
);

export default FiltersSection;
